import React, { Component } from 'react'
import { connect } from 'react-redux'

import './overview.scss'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

// Components
import OverviewOrderItem from './OverviewOrderItem'

// Elements
import Grid from '../../elements/grid'

class Overview extends Component {
  constructor (props) {
    super(props)

    this.pageRef = null

    this.state = {
      isLoading: false,
      statusGroups: [],
      itemsPerPage: 0,
      showAllCars: false
    }

    this.handleResize = this.handleResize.bind(this)
    this.renderStatusGroup = this.renderStatusGroup.bind(this)
    this.setRef = this.setRef.bind(this)
    this.updateInterval = null
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize)
    this.updateInterval = setInterval(() => { this.updateData() }, 60000)
    this.updateData()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
    clearInterval(this.updateInterval)
  }

  handleResize () {
    if (this.pageRef !== null) {
      const pageHeight = this.pageRef.clientHeight
      const itemHeight = 100

      const titleHeight = 178
      const paddingHeight = 48 * 2
      const itemsPerPage = Math.floor((pageHeight - titleHeight - paddingHeight - 64) / itemHeight)

      if (this.state.itemsPerPage !== itemsPerPage) {
        this.setState({
          itemsPerPage: itemsPerPage
        })
      }
    }
  }

  updateData () {
    this.setState({ isLoading: true }, () => {
      this.props.getItems().then((res) => {
        this.setState({
          statusGroups: res.data.Columns,
          isLoading: false
        })
      })
    })
  }

  setRef (comp) {
    const firstSetRef = this.pageRef === null
    this.pageRef = comp

    if (firstSetRef) {
      this.handleResize()
    }
  }

  toggle () {
    this.setState({
      showAllCars: true
    })
  }

  renderStatusGroup (statusGroup, key) {
    const renderItemList = () => {
      let bricks = []
      let brickCount
      let showAllCars = this.state.showAllCars
      let itemLength = showAllCars ? statusGroup.Items.length : this.state.itemsPerPage

      for (brickCount = 0; brickCount < itemLength && brickCount < statusGroup.Items.length; brickCount++) {
        const item = statusGroup.Items[brickCount]

        let renderItem
        switch (this.props.itemType) {
          case 'order':
            renderItem = <OverviewOrderItem
              OrderId={item.OrderId}
              BrandName={item.BrandName}
              Model={item.Model}
              RegNr={item.RegNr}
              PlateType={item.PlateType}
              OrderStep={item.OrderStep}
              SecondaryText={item.SecondaryText}
              key={brickCount}
            />
            break
          default:
            renderItem = null
            break
        }

        bricks = [
          ...bricks,
          renderItem
        ]
      }

      const count = statusGroup.ItemCount - brickCount
      return (
        <div className='overview__orderList'>
          {bricks}
          {!showAllCars && count > 0 && <div className='overview__rest' onClick={this.toggle.bind(this)}>
            {count > 0 && `+ ${count} ${translation('16604')}`}&nbsp;
          </div>}
        </div>
      )
    }

    return (
      <div className='overview__group' key={key}>
        <div className='overview__wrapper'>
          <div className='overview__title'>{translation(statusGroup.NameKey)}</div>
          {statusGroup.SubTitle !== null && (<div className='overview__subtitle'>{statusGroup.SubTitle}</div>)}
          <div className='overview__count'>{statusGroup.ItemCount}</div>
        </div>

        {renderItemList()}
      </div>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null

    return (
      <div className='overview' ref={this.setRef}>
        {this.state.isLoading && (
          <div className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <span className='sr-only'>{translation('13382')}...</span>
          </div>
        )}

        <Grid evenColumns>
          {this.state.statusGroups.map(this.renderStatusGroup)}
        </Grid>
      </div>
    )
  }
}

Overview.defaultProps = {
  title: '',
  getItems: undefined,
  itemType: 'order'
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
})(Overview)



// WEBPACK FOOTER //
// ./src/app/shared/components/Overview/index.js